export default theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
});



// WEBPACK FOOTER //
// ./src/containers/Login/styles.js